module.exports = __webpack_public_path__ + "assets/img/nx-06.daba22e1.jpg";